var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1207 0.816406H7.90973C7.41748 0.816406 7.03082 1.20307 7.03082 1.69531V23.668C7.03082 24.6348 6.23986 25.4258 5.27301 25.4258C4.78076 25.4258 4.3941 25.8124 4.3941 26.3047C4.3941 26.4425 4.04141 26.5692 3.53658 26.6788C3.14557 26.7637 3.11508 27.1836 3.5152 27.1836H25.605C28.0308 27.1836 29.9996 25.2148 29.9996 22.7891V1.69531C29.9996 1.20307 29.6129 0.816406 29.1207 0.816406Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 18.3945C0.393516 18.3945 0 18.788 0 19.2734V23.668C0 25.1094 0.896484 26.3749 2.14447 26.9023C2.16205 26.9199 2.16205 26.9023 2.16205 26.9023C2.55855 27.0841 2.98617 27.1726 3.43031 27.1827C5.41014 27.2271 7.03125 25.4633 7.03125 23.4829V18.3945H0.878906ZM10.6055 14.8789H17.6367C18.1225 14.8789 18.5156 14.4858 18.5156 14V6.96875C18.5156 6.48295 18.1225 6.08984 17.6367 6.08984H10.6055C10.1197 6.08984 9.72656 6.48295 9.72656 6.96875V14C9.72656 14.4858 10.1197 14.8789 10.6055 14.8789ZM21.2109 7.84766H26.4844C26.9702 7.84766 27.3633 7.45455 27.3633 6.96875C27.3633 6.48295 26.9702 6.08984 26.4844 6.08984H21.2109C20.7251 6.08984 20.332 6.48295 20.332 6.96875C20.332 7.45455 20.7251 7.84766 21.2109 7.84766ZM26.4844 9.60547H21.2109C20.7251 9.60547 20.332 9.99857 20.332 10.4844C20.332 10.9702 20.7251 11.3633 21.2109 11.3633H26.4844C26.9702 11.3633 27.3633 10.9702 27.3633 10.4844C27.3633 9.99857 26.9702 9.60547 26.4844 9.60547ZM26.4844 13.1211H21.2109C20.7251 13.1211 20.332 13.5142 20.332 14C20.332 14.4858 20.7251 14.8789 21.2109 14.8789H26.4844C26.9702 14.8789 27.3633 14.4858 27.3633 14C27.3633 13.5142 26.9702 13.1211 26.4844 13.1211ZM26.4844 16.6367H10.6055C10.1197 16.6367 9.72656 17.0298 9.72656 17.5156C9.72656 18.0014 10.1197 18.3945 10.6055 18.3945H26.4844C26.9702 18.3945 27.3633 18.0014 27.3633 17.5156C27.3633 17.0298 26.9702 16.6367 26.4844 16.6367ZM26.4844 20.1523H10.6055C10.1197 20.1523 9.72656 20.5454 9.72656 21.0312C9.72656 21.5171 10.1197 21.9102 10.6055 21.9102H26.4844C26.9702 21.9102 27.3633 21.5171 27.3633 21.0312C27.3633 20.5454 26.9702 20.1523 26.4844 20.1523Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di",
    x: -6.771,
    y: 0.816406,
    width: 46.7707,
    height: 46.3672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0672279,
    y1: -26.0781,
    x2: 36.1281,
    y2: -24.1155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 13.6816,
    y1: 27.1835,
    x2: 13.6816,
    y2: 6.08984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.42f0f2b197f5a0b3191ecdb63224ba0b.svg";
export { ForwardRef as ReactComponent };